import { LearnerStrugglingSummary } from "helpers/strugglingLearner";
import { useEffect, useState } from "react";
import { fetchStrugglingLearnerRoster } from "services/strugglingLearners";

/**
 * Loads org-scoped struggling-learner summaries from the API. Raw scores
 * never reach the browser. Pass no orgId to skip (e.g. "all organizations").
 */
export const useStrugglingLearnerRoster = (
  orgId?: string,
  studentId?: string,
) => {
  const [strugglingByStudentId, setStrugglingByStudentId] = useState<
    Map<string, LearnerStrugglingSummary>
  >(new Map());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!orgId) {
      setStrugglingByStudentId(new Map());
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    fetchStrugglingLearnerRoster(orgId, studentId)
      .then((roster) => {
        if (cancelled) return;
        setStrugglingByStudentId(
          new Map(
            roster.learners.map((summary) => [summary.studentId, summary]),
          ),
        );
      })
      .catch(() => {
        if (!cancelled) setStrugglingByStudentId(new Map());
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [orgId, studentId]);

  return { strugglingByStudentId, strugglingLoading: loading };
};
